<template>
    <div>
        <vx-card title="Credit Note Supplier Adjustment">
            <vs-tabs :color="colorx" v-model="tabs">
                <vs-tab @click="colorx = 'danger'" label="Open">
                    <div class="con-tab-ejemplo">
                        <open/>
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'warning'" label="Confirmed">
                    <div class="con-tab-ejemplo">
                        <confirm/>
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'success'" label="Canceled">
                    <div class="con-tab-ejemplo">
                        <cancel />
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'success'" label="Waiting Reverse">
                    <div class="con-tab-ejemplo">
                        <waiting />
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'success'" label="Reversed">
                    <div class="con-tab-ejemplo">
                        <reversed />
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>
<script>
import open from "./open/open.vue";
import confirm from "./confirm/confirm.vue";
import cancel from "./cancel/cancel.vue";
import waiting from "./waiting/waiting.vue";
import reversed from "./reversed/reversed.vue";
// import done from "./done.vue";

export default {
    components: {
        open,
        confirm,
        cancel,
        reversed,
        waiting,
    },
    data:() => ({
        colorx: "danger",
        tabs: 0,
    })
}
</script>